
import { createRadioBase } from 'JS/components/blain-form/BRadioBase';
import { DateRange } from 'JS/types/Generic';
import { defineComponent } from 'vue';

const { withRadioBaseProps, useRadioBase } = createRadioBase<DateRange>();

export default defineComponent({
	props: {
		...withRadioBaseProps(),
	},
	setup (props, { emit }) {
		return {
			...useRadioBase(props, emit)
		};
	}
});
